import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../api/client";
import { MOBILE } from "../../constants/testIds";
import { StatusBadge } from "../../components/shared/StatusBadge";
import { Search, Play } from "lucide-react";

export default function MobileJobs() {
    const [jobs, setJobs] = useState([]);
    const [q, setQ] = useState("");
    const nav = useNavigate();
    useEffect(() => {
        api.get("/jobs", { params: q ? { q } : {} }).then((r) => setJobs(r.data.slice(0, 30)));
    }, [q]);
    return (
        <div data-testid={MOBILE.jobsRoot} className="px-5 pb-32">
            <div className="relative mt-2 mb-3">
                <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted" />
                <input
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    placeholder="Search"
                    className="w-full h-11 pl-9 pr-3 rounded-xl bg-white border border-km text-sm"
                />
            </div>
            <ul className="space-y-2">
                {jobs.map((j) => (
                    <li key={j.id}>
                        <button
                            onClick={() => nav(`/m/job/${j.id}`)}
                            className="w-full km-card p-3 flex items-center gap-3 text-left"
                        >
                            <div className="w-11 h-11 rounded-lg bg-[color:var(--km-navy-l)] text-[color:var(--km-navy)] flex items-center justify-center num font-bold text-sm">
                                {j.job_number || "—"}
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="text-sm text-ink truncate">{j.address}</div>
                                <div className="mt-1"><StatusBadge status={j.status} /></div>
                            </div>
                            <Play size={16} className="text-[color:var(--km-green)]" fill="currentColor" />
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
